import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWindow = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M7 40q-1.2 0-2.1-.9T4 37V11q0-1.2.9-2.1T7 8h34q1.2 0 2.1.9T44 11v26q0 1.2-.9 2.1T41 40zm0-3h34V15.2H7z" })
});
export default SvgWindow;
